import { apiClient } from "@/features/shared";

import { ProductSelectBase } from "./product-select-base";

// Global product picker — queries the master product list (not outlet-scoped).
// Use on org-level screens such as warehouse stock. For transaction forms that
// need the current outlet's products, use OutletProductSelect instead.
export const ProductSelect = (props) => (
  <ProductSelectBase client={apiClient} {...props} />
);
